import { render, staticRenderFns } from "./FinishStatusComponent.vue?vue&type=template&id=185cb21e&scoped=true"
import script from "./FinishStatusComponent.vue?vue&type=script&lang=ts"
export * from "./FinishStatusComponent.vue?vue&type=script&lang=ts"
import style0 from "./FinishStatusComponent.vue?vue&type=style&index=0&id=185cb21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185cb21e",
  null
  
)

export default component.exports